import { Component } from '@angular/core';
import { SHARED_IMPORTS } from '../../shared/shared-imports';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'app-landing-layout',
  templateUrl: './landing-layout.component.html',
  styleUrls: ['./landing-layout.component.scss'],
  imports: [SHARED_IMPORTS]
})
export class LandingLayoutComponent  {
  menuItems = [
    { label: 'Inicio', routerLink: '/,', icon: 'pi pi-home' },
    // { label: 'Cómo Funciona', routerLink: '/how-it-works' },
    // { label: 'Precios', routerLink: '/pricing' },
    { label: 'Registrarse', routerLink: '/auth/register', icon: 'pi pi-user-plus' },
    { label: 'Login', routerLink: '/auth', icon: 'pi pi-user' }
  ];

  constructor(title: Title, meta: Meta) {
    title.setTitle('Chats Random! – Conecta al instante');
    meta.addTags([
      { name: 'description', content: 'Charla con personas al azar en segundos: gratis, anónimo y sin likes.' },
      { name: 'keywords',    content: 'chat aleatorio, conocer gente, charlas random' },
      { name: 'robots',      content: 'index,follow' }
    ]);
  }
  

}
